<template>
  <div
    class="Slide pb-4"
    :id="galleryContent.sections[sectionIndex].subsections[slideIndex].id"
    :style="{ 'background-image': 'url(./static/images/gallery/' + galleryContent.sections[sectionIndex].directory + '/' + galleryContent.sections[sectionIndex].subsections[slideIndex].backgroundImgFileName + ')' }"
  >
  <!-- <div
    class="Slide pb-4"
    @wheel="debouncedScroll($event, slideIndex)"
    :id="galleryContent.sections[sectionIndex].subsections[slideIndex].id"
    :style="{ 'background-image': 'url(./static/images/gallery/' + galleryContent.sections[sectionIndex].directory + '/' + galleryContent.sections[sectionIndex].subsections[slideIndex].backgroundImgFileName + ')' }"
  > -->

    <div class="container">

      <div class="row">
        <div class="col mt-3">
          <div 
            class="ButtonIcon ButtonIcon--small ButtonIcon--light mx-auto"
            title="Return to Top"
            @click="jumpToId('app')">
            <icon name="arrow-up" scale=".85"></icon>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col my-3 text-center">
          <h4 class="Slide-goHome" @click="jumpToId('app')">Return to Top</h4>
        </div>
      </div>

      <app-image-slider 
        :id="'gallery-' + slideIndex"
        :imageLs="galleryContent.sections[sectionIndex].subsections[slideIndex].images"
        :parentDir="'gallery' + '/' + galleryContent.sections[sectionIndex].directory"/>

    </div>
    
  </div>
</template>

<script>
import appImageSlider from './../partials/imageSlider'
import jump from 'jump.js'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/arrow-up'

const _ = require('lodash')

export default {
  name: 'gallerySlide',

  components: {
    appImageSlider,
    Icon
  },

  props: {
    sectionIndex: Number,
    slideIndex: Number
  },

  computed: {
    galleryContent () {
      return this.$store.getters.galleryContent
    }
  },

  methods: {
    debouncedScroll: _.throttle(function (e, id) {
      // mousewheel delta for IE
      const delta = (e.wheelDelta * -1) || e.deltaY
      const currentSectionId = this.galleryContent.sections[this.sectionIndex].subsections[id].id
      const currentSection = document.getElementById(currentSectionId).getBoundingClientRect()
      // const yDif = currentSection.y > 0 ? currentSection.top : (currentSection.top * -1)
      // console.log(document.documentElement.clientHeight + yDif - 30, currentSection.height)
      // console.log(document.documentElement.clientHeight, currentSection)
      if (delta < 0 && id === 0) {
        jump('#app')
      } else if (delta > 0) {
        // if (document.documentElement.clientHeight + yDif >= currentSection.height) {
        //   const section = this.galleryContent.sections[this.sectionIndex].subsections[id + 1].id
        //   jump('#' + section, {
        //     offset: -80
        //   })
        // }
      } else if (delta < 0) {
        if (currentSection.height > 70) {
          const section = this.galleryContent.sections[this.sectionIndex].subsections[id - 1].id
          jump('#' + section, {
            offset: -80
          })
        }
      }
    }, 1000, {
      'leading': true,
      'trailing': false
    }),

    jumpToId (selector) {
      const id = '#' + selector
      jump(id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';

.Slide {
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 100vh;
}

.Slide-goHome {
  color: $offwhite;
  cursor: pointer;
  transition: $transitionHover;
  &:hover {
    color: $gold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/gallery/gallery-slide.vue